<template>
  <div>
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="图标列表">
        <IconList></IconList>
      </a-tab-pane>
      <a-tab-pane key="2" tab="分类列表" force-render>
        <CateList></CateList>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import IconList from "./components/IconList";
import CateList from "./components/CateList";
export default {
  name: "index",
  data() {
    return {};
  },
  created() {
    this.$store.state.adminleftnavnum = "/UserBackground/IconLibrary"; //设置左侧导航2-2 active
  },
  components: { IconList, CateList },
  methods: {
    callback(key) {}
  }
};
</script>

<style scoped></style>
